import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  List,
  ListIcon,
  ListItem,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useContext, useEffect, useMemo, useState } from 'react'
import CurrencyFormat from 'react-currency-format'
import { SubmitHandler, useForm } from 'react-hook-form'
import { RiCheckLine } from 'react-icons/ri'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useLocation } from 'react-router-dom'
import { Step } from '../../../Enuns/step.enum'
import { Demand } from '../../../Interfaces/demands'
import { Product } from '../../../Interfaces/products'
import { RawMaterial } from '../../../Interfaces/rawMaterial'
import { ServiceOrders } from '../../../Interfaces/serviceOrders'
import { ServiceRawMaterials } from '../../../Interfaces/serviceRawMaterials'
import { WorkSchedule } from '../../../Interfaces/workSchedule'
import { CoastRawMaterial } from '../../../components/CoastRawMaterial'
import { Input } from '../../../components/Form/Input'
import { Select } from '../../../components/Form/Select'
import { Modal } from '../../../components/Modal'
import { ServiceOrderGradeList } from '../../../components/ServiceOrderGradeList'
import { useAuth } from '../../../context/AuthContext'
import { ConfigurationContext } from '../../../context/ConfigurationContext'
import { api } from '../../../services/api'
import { pdfRows } from '../../../utils/pdfRows'
import { serviceOrderStatusOptions } from '../../../utils/status'
import ProdcutsCreateOrUpdate from '../prodcuts/form'
import { FinishOrderModal } from './FinishOrder/FinishOrderModal'
import { PrintEtiquetaModal } from './PrintEtiquetaModal'
import RawMaterialServiceCreateOrUpdate from './rawMaterialService/form'
import WorkScheduleCreateOrUpdate from './workSchedule/form'

export interface WorkSchedulesTypes {
  all?: WorkSchedule[]
  cleaning: WorkSchedule[]
  painting: WorkSchedule[]
  packaging: WorkSchedule[]
}

export function ServiceOrderList({ match }: any) {
  const { id, demandId }: { id: string; demandId: string } = match.params

  const { search } = useLocation()
  const delivered = new URLSearchParams(search).get('delivered')

  // hooks
  const toast = useToast()
  const { hasPermission, isAdmin, user } = useAuth()

  // Buscar dados atualizados do usuário se o access não estiver disponível
  const { data: currentUser } = useQuery(
    'currentUser',
    async () => {
      const response = await api.get('/me')
      return response.data
    },
    {
      enabled: !user?.access, // Só busca se o access não estiver disponível
      retry: false,
      staleTime: 5 * 60 * 1000, // Cache por 5 minutos
    },
  )

  const effectiveUser = currentUser || user
  const userAccessUpper = effectiveUser?.access ? String(effectiveUser.access).toUpperCase() : ''
  const isUserAdmin = isAdmin || userAccessUpper === 'ADMIN' || userAccessUpper === 'ADMINISTRADOR'
  const canViewFinancialData = isUserAdmin || hasPermission('view_financial_data_on_demand')
  const { configuration } = useContext(ConfigurationContext)
  const { isOpen: isCreateOpen, onOpen: onCreateOpen, onClose: onCreateClose } = useDisclosure()
  const { isOpen: isCreateScheduleOpen, onOpen: onCreateScheduleOpen, onClose: onCreateScheduleClose } = useDisclosure()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const {
    isOpen: isRemoveWorkSchedule,
    onOpen: onRemoveWorkScheduleOpen,
    onClose: onRemoveWorkScheduleClose,
  } = useDisclosure()

  const {
    isOpen: isCreateRawMaterial,
    onOpen: onCreateRawMaterialOpen,
    onClose: onCreateRawMaterialClose,
  } = useDisclosure()

  const {
    isOpen: isRemoveRawMaterial,
    onOpen: onRemoveRawMaterialOpen,
    onClose: onRemoveRawMaterialClose,
  } = useDisclosure()

  const { isOpen: isFinishOrderOpen, onOpen: onFinishOrderOpen, onClose: onFinishOrderClose } = useDisclosure()

  const { isOpen: isPrintEtiquetaOpen, onOpen: onPrintEtiquetaOpen, onClose: onPrintEtiquetaClose } = useDisclosure()
  const { isOpen: isTestBitmapOpen, onOpen: onTestBitmapOpen, onClose: onTestBitmapClose } = useDisclosure()

  // States
  const [selectedProduct, setSelectedProduct] = useState<Product>()

  const [cleaningRows, setCleaningRows] = useState<number>()
  const [packgingRows, setPackgingRows] = useState<number>()
  const [paitingRows, setPaitingRows] = useState<number>()
  const [productRows, setProductRows] = useState<number>()

  const [selectedWorkSchedule, setSelectedWorkSchedule] = useState<WorkSchedule | undefined>()

  const [selectedRawMaterial, setSelectedRawMaterial] = useState<ServiceRawMaterials>()

  const [serviceOrderPrice, setServiceOrderPrice] = useState(0)

  const [rawMaterialsCleaning, setRawMaterialsCleaning] = useState<RawMaterial[]>([])
  const [rawMaterialsPackaging, setRawMaterialsPackaging] = useState<RawMaterial[]>([])
  const [rawMaterialsPainting, setRawMaterialsPainting] = useState<RawMaterial[]>([])

  const [step, setStep] = useState()

  const [liquidValue, setLiquidValue] = useState<number>(0)
  const [ovenBurnCost, setOvenBurnCost] = useState<number>(0)
  const [selectedOvenSpace, setSelectedOvenSpace] = useState<number>(0)
  const [isReopened, setIsReopened] = useState<boolean>(false)
  const [isPrintingEtiqueta, setIsPrintingEtiqueta] = useState<boolean>(false)

  const queryClient = useQueryClient()

  const { data: demands } = useQuery(
    'demand',
    async () => {
      const response = await api.get<Demand>(`demands/${demandId}`)

      return response.data
    },
    { retry: false },
  )

  const { data: serviceOrder, refetch } = useQuery(
    'serviceOrderProduct',
    async () => {
      const response = await api.get<ServiceOrders>(`/demands/${demandId}/service-orders/${id}`)

      const cleaning = []
      const painting = []
      const packaging = []

      response.data.serviceRawMaterials.forEach((x) => {
        const rawMaterial = response.data.rawMaterials.find((y) => y.id === x.raw_material_id)
        if (!rawMaterial) {
          console.warn(`Matéria-prima não encontrada para ID: ${x.raw_material_id}`)
          return
        }

        switch (x.step) {
          case Step.EMBALAGEM:
            packaging.push(
              response.data.rawMaterials
                .filter((y) => y.id === x.raw_material_id)
                .map((k) => ({ ...k, spent_amount: x.spent_amount })),
            )
            break
          case Step.PINTURA:
            painting.push(
              response.data.rawMaterials
                .filter((y) => y.id === x.raw_material_id)
                .map((k) => ({ ...k, spent_amount: x.spent_amount })),
            )
            break
          default:
            cleaning.push(
              response.data.rawMaterials
                .filter((y) => y.id === x.raw_material_id)
                .map((k) => ({ ...k, spent_amount: x.spent_amount })),
            )
            break
        }
      })

      setRawMaterialsCleaning(cleaning.map((x) => ({ ...x })))
      setRawMaterialsPackaging(packaging)
      setRawMaterialsPainting(painting)

      return response.data
    },
    {
      retry: false,
    },
  )

  const { data: workSchedules, refetch: workRefetch } = useQuery(
    'workSchedule',
    async () => {
      const response = await api.get<WorkSchedule[]>(`/service-orders/${id}/work-schedules`)

      const cleaning = []
      const painting = []
      const packaging = []

      response.data.forEach((x) => {
        switch (x.step) {
          case Step.EMBALAGEM:
            packaging.push(x)
            break
          case Step.PINTURA:
            painting.push(x)
            break
          default:
            cleaning.push(x)
            break
        }
      })

      return {
        all: response.data,
        cleaning,
        painting,
        packaging,
      } as WorkSchedulesTypes
    },
    {
      retry: false,
    },
  )

  const handleAction = (product = null) => {
    refetch()
    setSelectedProduct({} as Product)

    if (!product) {
      onCreateOpen()
    } else {
      delete product.formatedDeliveryDate

      setSelectedProduct(product)
      product.deleted ? onOpen() : onCreateOpen()
    }
  }

  const handleRemoveButton = () => {
    if (selectedProduct) removeDemand.mutateAsync(selectedProduct)

    onClose()
  }

  const removeDemand = useMutation(
    async (product: Product) => {
      const response = await api.delete(`products/${product.id}`)

      if (response) {
        toast({ description: 'Removido com sucesso', status: 'success' })
        refetch()
        queryClient.invalidateQueries('serviceOrderProduct')
      }
      onClose()
      return response.data
    },
    {
      onError: ({ response }) => {
        const errorList = response.data.errors

        if (errorList) {
          const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' }))
          toastOptions.forEach((t) => {
            toast(t)
          })
        } else {
          toast({ description: 'Falha ao remover pedido', status: 'error' })
        }
      },
    },
  )

  const { register, handleSubmit, setValue, getValues } = useForm({
    mode: 'onSubmit',
  })

  useEffect(() => {
    setValue('status', serviceOrder?.status)
    setValue('num_resp_cleaning', serviceOrder?.num_resp_cleaning)
    setValue('num_resp_painting', serviceOrder?.num_resp_painting)
    setValue('num_resp_packaging', serviceOrder?.num_resp_packaging)
  }, [serviceOrder])

  useEffect(() => {
    calculateLiquid()
  }, [serviceOrder, workSchedules?.all, configuration])

  const calculateLiquid = () => {
    let totalProducts = 0
    let burnCost = 0
    let serviceCost = 0
    let laborCost = 0
    let materialCost = 0

    // 1️⃣ Soma do valor total dos produtos (preço unitário * quantidade)
    if (serviceOrder?.products?.length) {
      totalProducts = serviceOrder.products.reduce(
        (total, product) => total + (Number(product.price) || 0) * (Number(product.amount) || 0),
        0,
      )
    }

    // 2️⃣ Calcular o valor total das queimadas de todos os produtos
    if (serviceOrder?.products?.length) {
      burnCost = serviceOrder.products.reduce((total, product) => {
        // Se o produto tem queimadas, soma o valor de cada uma
        if (product.burns && Array.isArray(product.burns) && product.burns.length > 0) {
          const productBurnsTotal = product.burns.reduce((sum, burn) => sum + (Number(burn.burn_value) || 0), 0)
          return total + productBurnsTotal
        }
        return total
      }, 0)
    }

    // 3️⃣ Somar custos adicionais de serviços (limpeza, pintura, embalagem)
    const cleaningCost = Number(serviceOrder?.num_resp_cleaning) || 0
    const paintingCost = Number(serviceOrder?.num_resp_painting) || 0
    const packagingCost = Number(serviceOrder?.num_resp_packaging) || 0
    serviceCost = cleaningCost + paintingCost + packagingCost

    // 4️⃣ Calcular custo da mão de obra (somar os total_value dos workSchedules)
    if (workSchedules && workSchedules.all && workSchedules.all.length) {
      laborCost = workSchedules.all.reduce((prev, curr) => {
        return prev + (Number(curr.total_value) || 0)
      }, 0)
    }

    // 5️⃣ Calcular custo da matéria-prima (quantidade usada * preço unitário)
    if (serviceOrder?.serviceRawMaterials?.length) {
      materialCost = serviceOrder.serviceRawMaterials.reduce((sum, materialOrder) => {
        const rawMaterial = serviceOrder.rawMaterials.find((x) => x.id === materialOrder.raw_material_id)
        if (!rawMaterial) {
          console.warn(`Matéria-prima não encontrada para ID: ${materialOrder.raw_material_id}`)
          return sum
        }
        return sum + (Number(materialOrder.spent_amount) || 0) * (Number(rawMaterial.price) || 0)
      }, 0)
    }

    // 6️⃣ Calcular valor líquido (bruto - custos)
    const liquidValue = totalProducts - (burnCost + serviceCost + laborCost + materialCost)

    setLiquidValue(Number.isFinite(liquidValue) ? liquidValue : 0)
    setServiceOrderPrice(totalProducts)
  }

  const changeStatus = useMutation(
    async (order: any) => {
      // Remover campos não suportados pelo model no backend
      const { oven_burn_cost, oven_space, ...orderData } = order

      const payload = {
        ...orderData,
        num_resp_cleaning: Number(order.num_resp_cleaning),
        num_resp_painting: Number(order.num_resp_painting),
        num_resp_packaging: Number(order.num_resp_packaging),
      }

      const response = await api.put(`/demands/${demands.id}/service-orders/${serviceOrder.id}`, payload)

      // Atualizar o valor do formulário com o status retornado
      const updatedStatus = response.data?.status || response.data?.data?.status
      if (updatedStatus) {
        setValue('status', updatedStatus)
      }
    },
    {
      onSuccess: () => {
        // Invalidar e refetch para garantir dados atualizados
        queryClient.invalidateQueries('serviceOrderProduct')
        refetch()
      },
      onError: (error: any) => {
        const errorList = error?.response?.data?.errors

        if (errorList && Array.isArray(errorList)) {
          const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' as const }))
          toastOptions.forEach((t) => {
            toast(t)
          })
        } else {
          toast({ description: 'Erro ao atualizar ordem de serviço', status: 'error' as const })
        }
      },
    },
  )

  const reopenOrder = useMutation(
    async () => {
      const response = await api.put(`/demands/${demands.id}/service-orders/${serviceOrder.id}`, {
        status: 'CONCLUIDO',
      })

      return response.data
    },
    {
      onSuccess: () => {
        setIsReopened(true)
        toast({ description: 'Ordem de serviço reaberta com sucesso', status: 'success' })
        // Invalidar e refetch para garantir dados atualizados
        queryClient.invalidateQueries('serviceOrderProduct')
        queryClient.invalidateQueries('demand')
        queryClient.invalidateQueries('demands') // Invalida a lista de demands que mostra o status
        refetch()
      },
      onError: () => {
        toast({ description: 'Erro ao reabrir ordem de serviço', status: 'error' })
      },
    },
  )

  const updateProductsOvenSpace = useMutation(
    async (newOvenSpace: number) => {
      if (!serviceOrder?.products?.length) return

      // Atualizar cada produto com o novo oven_space
      const updatePromises = serviceOrder.products.map((product) => {
        // Remover campos computados e não suportados pelo backend
        const { formatedDeliveryDate, ...productData } = product as any

        return api.put(`/products/${product.id}`, {
          ...productData,
          oven_space: newOvenSpace,
        })
      })

      await Promise.all(updatePromises)
    },
    {
      onSuccess: () => {
        toast({ description: 'Produtos atualizados com nova queimada', status: 'success' })
        queryClient.invalidateQueries('serviceOrderProduct')
      },
      onError: (error) => {
        console.log(error)
        toast({ description: 'Erro ao atualizar produtos', status: 'error' })
      },
    },
  )

  const handleCreateOrUpdate: SubmitHandler<any> = async (values) => {
    try {
      calculateLiquid()
      delete values.product_rows
      delete values.cleaning_rows
      delete values.painting_rows
      delete values.packaging_rows

      await changeStatus.mutateAsync(values)
    } catch (error) {
      // Erro já tratado na mutation
    }
  }

  const handleWorkSchedule = (step, workSchedule = null) => {
    setStep(step)

    if (!workSchedule) {
      setSelectedWorkSchedule(undefined)
      onCreateScheduleOpen()
    } else {
      setSelectedWorkSchedule(workSchedule)
      workSchedule.deleted ? onRemoveWorkScheduleOpen() : onCreateScheduleOpen()
    }
  }

  const handleRawMaterial = (step, rawMaterial = null) => {
    setStep(step)

    setSelectedRawMaterial({} as ServiceRawMaterials)

    if (!rawMaterial) {
      onCreateRawMaterialOpen()
    } else {
      setSelectedRawMaterial(rawMaterial[0])
      rawMaterial.deleted ? onRemoveRawMaterialOpen() : onCreateRawMaterialOpen()
    }
  }

  const handleWorkScheduleremove = () => {
    if (selectedWorkSchedule) removeWorkSchedule.mutateAsync(selectedWorkSchedule)

    onRemoveWorkScheduleClose()
  }

  const removeWorkSchedule = useMutation(
    async (work: any) => {
      const response = await api.delete(`/service-orders/${serviceOrder.id}/work-schedules/${work.id}`)

      if (response) {
        toast({ description: 'Removido com sucesso', status: 'success' })
        workRefetch()
      }

      onRemoveWorkScheduleClose()
      return response.data
    },
    {
      onError: ({ response }) => {
        const errorList = response.data.errors

        if (errorList) {
          const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' }))
          toastOptions.forEach((t) => {
            toast(t)
          })
        } else {
          toast({ description: 'Falha ao remover pedido', status: 'error' })
        }
      },
    },
  )

  const handleRawMaterialRemove = () => {
    if (selectedRawMaterial) removeRaw.mutateAsync(selectedRawMaterial)

    onRemoveRawMaterialClose()
  }

  const removeRaw = useMutation(
    async (work: any) => {
      const response = await api.delete(`/service-orders/${serviceOrder.id}/raw-materials/${work.id}`)

      if (response) {
        toast({ description: 'Removido com sucesso' })
        refetch()
        // queryClient.invalidateQueries('demands')
        // queryClient.invalidateQueries('serviceOrderProduct')
      }

      onRemoveWorkScheduleClose()
      return response.data
    },
    {
      onError: ({ response }) => {
        const errorList = response.data.errors

        if (errorList) {
          const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' }))
          toastOptions.forEach((t) => {
            toast(t)
          })
        } else {
          toast({ description: 'Falha ao remover pedido', status: 'error' })
        }
      },
    },
  )

  const handlePrintOrder = async () => {
    const response = await api.get(`/demands/${demandId}/service-orders/${id}/generate-pdf`, {
      responseType: 'blob',
      params: {
        packaging_rows: packgingRows,
        cleaning_rows: cleaningRows,
        painting_rows: paitingRows,
        product_rows: productRows,
      },
    })

    const file = new Blob([response.data], { type: 'application/pdf' })

    window.open(URL.createObjectURL(file), '_blank')
  }

  const handlePrintEtiqueta = async (selectedProductIds: number[], multipleProductsOnSameLabel: boolean) => {
    try {
      setIsPrintingEtiqueta(true)

      const response = await api.post(`/demands/${demandId}/service-orders/${id}/generate-etiqueta`, {
        product_ids: selectedProductIds,
        multiple_products_on_same_label: multipleProductsOnSameLabel,
      })

      if (response.status === 200) {
        toast({
          description: response.data.message,
          status: 'success',
        })
        onPrintEtiquetaClose()
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.error?.message || 'Erro ao gerar a etiqueta'
      toast({
        description: errorMessage,
        status: 'error',
      })
    } finally {
      setIsPrintingEtiqueta(false)
    }
  }

  const timeToDate = (time: string) => {
    const t = time.split(':')

    const d = new Date()

    d.setHours(Number(t[0] || 0), Number(t[1] || 0), Number(t[2] || 0))

    return d
  }

  // Verifica se a ordem está entregue e não foi reaberta
  const isOrderDelivered = serviceOrder?.status === 'ENTREGUE' && !isReopened
  const canEdit = !isOrderDelivered

  // Verifica se todos os produtos estão com etapa CONCLUIDO
  // Se não houver produtos, considera como concluído (array vazio retorna true no every)
  const allProductsCompleted =
    serviceOrder?.products && serviceOrder.products.length > 0
      ? serviceOrder.products.every((product) => product.step === 'CONCLUIDO')
      : true // Se não houver produtos, permite finalizar

  // Permite finalizar se: status é CONCLUIDO (incluindo quando foi reaberto) E todos os produtos estão concluídos
  const canFinishOrder =
    (serviceOrder?.status === 'CONCLUIDO' || (serviceOrder?.status === 'ENTREGUE' && isReopened)) &&
    allProductsCompleted

  // Debug temporário
  if (process.env.NODE_ENV === 'development') {
    console.log('Debug finalizar ordem:', {
      status: serviceOrder?.status,
      isReopened,
      allProductsCompleted,
      canFinishOrder,
      canViewFinancialData,
      isAdmin,
      isUserAdmin,
      userAccess: effectiveUser?.access,
      userAccessUpper,
      user: effectiveUser, // Mostrar o objeto user completo para debug
      currentUserFromAPI: currentUser, // Mostrar se foi buscado da API
      products: serviceOrder?.products?.map((p) => ({ id: p.id, step: p.step })),
    })
  }

  // Adiciona a opção ENTREGUE às opções do select se o status atual for ENTREGUE
  const statusOptions = useMemo(() => {
    if (serviceOrder?.status === 'ENTREGUE') {
      return [...serviceOrderStatusOptions, { label: 'ENTREGUE', value: 'ENTREGUE' }]
    }
    return serviceOrderStatusOptions
  }, [serviceOrder?.status])

  return (
    <>
      <Box flex="1" borderRadius="8" bg="gray.800" p="8" as="form">
        <Flex mb="8" justifyContent="space-between" align="flex-end">
          <Box>
            <Heading size="lg" fontWeight="normal" mb="2">
              Ordem de serviço Nº {id}
            </Heading>
            <VStack spacing="8" as="form" display={delivered ? 'none' : 'flex'}>
              <Select
                label="Status ordem de serviço"
                {...register('status')}
                options={statusOptions}
                onChange={(e) => {
                  setValue('status', e.target.value)
                  handleSubmit(handleCreateOrUpdate)()
                }}
                placeholder="Selecione"
                isDisabled={!canEdit}
              />
            </VStack>
            <Text fontSize="1xl" mt="10">
              <Text fontSize="2xl" bg="gray.400" p={1} borderRadius={10}>
                {demands?.client?.company_name}
              </Text>
            </Text>
          </Box>
          {canViewFinancialData && (
            <Flex gridGap="1rem">
              <Text fontSize="2xl" mb="2" bg="pink.400" py="2" px="10" borderRadius={10}>
                Bruto:
                {
                  <CurrencyFormat
                    displayType="text"
                    decimalSeparator=","
                    thousandSeparator="."
                    prefix="R$ "
                    decimalScale={2}
                    fixedDecimalScale
                    value={Number.isFinite(serviceOrderPrice) ? serviceOrderPrice : 0}
                  />
                }
              </Text>
              {canViewFinancialData && (
                <Text fontSize="2xl" mb="2" bg="green.400" py="2" px="10" borderRadius={10}>
                  <Stack direction={['column', 'row']} spacing="5px">
                    <span>Líquido: R$ </span>
                    {
                      <CurrencyFormat
                        displayType="text"
                        decimalSeparator=","
                        thousandSeparator="."
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale
                        value={Number.isFinite(liquidValue) ? liquidValue : 0}
                      />
                    }
                  </Stack>
                </Text>
              )}
            </Flex>
          )}
        </Flex>

        <Divider my="6" borderColor="gray.700" />

        {/* Exibe informações de pagamento quando a ordem está entregue */}
        {isOrderDelivered && serviceOrder?.recipes && serviceOrder.recipes.length > 0 && (
          <Box mb="6" p="6" bg="gray.800" borderRadius="md">
            <Heading size="md" mb="4" color="gray.100">
              Informações de Pagamento
            </Heading>
            <Table variant="simple" colorScheme="whiteAlpha" size="sm">
              <Thead>
                <Tr>
                  <Th color="gray.300">Parcela</Th>
                  <Th color="gray.300">Forma de Pagamento</Th>
                  <Th color="gray.300">Condição de Pagamento</Th>
                  <Th isNumeric color="gray.300">
                    Valor
                  </Th>
                  <Th isNumeric color="gray.300">
                    Desconto
                  </Th>
                  <Th isNumeric color="gray.300">
                    Juros
                  </Th>
                  <Th isNumeric color="gray.300">
                    Valor Líquido
                  </Th>
                  <Th color="gray.300">Vencimento</Th>
                  <Th color="gray.300">Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {serviceOrder.recipes.map((recipe) => (
                  <Tr key={recipe.id}>
                    <Td>
                      <Badge colorScheme="purple">
                        {recipe.installment_number}/{serviceOrder.recipes?.length || 1}
                      </Badge>
                    </Td>
                    <Td>{recipe.paymentMethod?.name || '-'}</Td>
                    <Td>{recipe.paymentCondition?.name || '-'}</Td>
                    <Td isNumeric>
                      <CurrencyFormat
                        displayType="text"
                        decimalSeparator=","
                        thousandSeparator="."
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale
                        value={Number(recipe.value) || 0}
                      />
                    </Td>
                    <Td isNumeric>
                      <CurrencyFormat
                        displayType="text"
                        decimalSeparator=","
                        thousandSeparator="."
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale
                        value={Number(recipe.discount_value) || 0}
                      />
                    </Td>
                    <Td isNumeric>
                      <CurrencyFormat
                        displayType="text"
                        decimalSeparator=","
                        thousandSeparator="."
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale
                        value={Number(recipe.interest_value) || 0}
                      />
                    </Td>
                    <Td isNumeric>
                      <Text fontWeight="bold" color="green.400">
                        <CurrencyFormat
                          displayType="text"
                          decimalSeparator=","
                          thousandSeparator="."
                          prefix="R$ "
                          decimalScale={2}
                          fixedDecimalScale
                          value={Number(recipe.net_value) || Number(recipe.value) || 0}
                        />
                      </Text>
                    </Td>
                    <Td>{recipe.due_date ? new Date(recipe.due_date).toLocaleDateString('pt-BR') : '-'}</Td>
                    <Td>
                      <Badge
                        colorScheme={
                          recipe.receipt_status === 'RECEBIDO' || recipe.receipt_status === 'PAGO'
                            ? 'green'
                            : recipe.receipt_status === 'PENDENTE'
                            ? 'yellow'
                            : 'gray'
                        }>
                        {recipe.receipt_status === 'RECEBIDO' || recipe.receipt_status === 'PAGO'
                          ? 'Pago'
                          : recipe.receipt_status === 'PENDENTE'
                          ? 'Pendente'
                          : recipe.receipt_status || '-'}
                      </Badge>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Box mt="4" pt="4" borderTop="1px" borderColor="gray.700">
              <Flex justify="space-between" align="center">
                <Text fontSize="lg" fontWeight="bold" color="gray.300">
                  Valor Total da Ordem:
                </Text>
                <Text fontSize="xl" fontWeight="bold" color="pink.400">
                  <CurrencyFormat
                    displayType="text"
                    decimalSeparator=","
                    thousandSeparator="."
                    prefix="R$ "
                    decimalScale={2}
                    fixedDecimalScale
                    value={
                      serviceOrder.recipes && serviceOrder.recipes.length > 0
                        ? serviceOrder.recipes.reduce((total, recipe) => {
                            const recipeValue = Number(recipe.value) || 0
                            return total + recipeValue
                          }, 0)
                        : Number(serviceOrderPrice) || 0
                    }
                  />
                </Text>
              </Flex>
            </Box>
          </Box>
        )}

        <Box display={delivered ? 'none' : ''}>
          {isOrderDelivered && (
            <Box mb="4" p="4" bg="red.100" borderRadius="md" border="1px" borderColor="red.300">
              <Text color="red.700" fontWeight="bold" mb="2">
                Ordem de Serviço Entregue
              </Text>
              <Text color="red.600" mb="3">
                Esta ordem foi finalizada e entregue. Para fazer alterações, reabra a ordem.
              </Text>
              <Button
                colorScheme="orange"
                size="sm"
                onClick={() => reopenOrder.mutate()}
                isLoading={reopenOrder.isLoading}>
                Reabrir Ordem
              </Button>
            </Box>
          )}

          <VStack spacing="8" as="form" mb="10">
            <Select
              label="Quantidade de linhas"
              {...register('product_rows')}
              options={pdfRows}
              onChange={(e) => {
                setProductRows(Number(e.target.value))
              }}
              placeholder="Selecione"
              isDisabled={!canEdit}
            />
          </VStack>

          <ServiceOrderGradeList
            title="Produtos"
            products={serviceOrder?.products}
            handleAction={handleAction}
            isDisabled={!canEdit}
          />

          <Divider my="6" borderColor="gray.700" />
          <VStack spacing="8" as="form" mb="2">
            <Input
              label="Custo de LIMPEZA"
              type="number"
              {...register('num_resp_cleaning')}
              onBlur={(e) => {
                const value = e.target.value

                if (value && !isNaN(Number(value))) {
                  setValue('num_resp_cleaning', Number(value))
                  handleSubmit(handleCreateOrUpdate)()
                }
              }}
              isDisabled={!canEdit}
            />
          </VStack>
          <VStack spacing="8" as="form" mb="10">
            <Select
              label="Quantidade de linhas"
              {...register('cleaning_rows')}
              options={pdfRows}
              onChange={(e) => {
                setCleaningRows(Number(e.target.value))
              }}
              placeholder="Selecione"
            />
          </VStack>
          <CoastRawMaterial
            title="Limpeza"
            workSchedules={workSchedules?.cleaning}
            rawMaterials={rawMaterialsCleaning}
            handleWorkSchedule={handleWorkSchedule}
            handleRawMaterial={handleRawMaterial}
            step={Step.LIMPEZA}
            isDisabled={!canEdit}
          />
          <VStack spacing="8" as="form" mb="2">
            <Input
              label="Custo de PINTURA"
              {...register('num_resp_painting')}
              onBlur={(e) => {
                setValue('num_resp_painting', e.target.value)
                handleSubmit(handleCreateOrUpdate)()
              }}
              isDisabled={!canEdit}
            />
          </VStack>
          <VStack spacing="8" as="form" mb="10">
            <Select
              label="Quantidade de linhas"
              {...register('painting_rows')}
              options={pdfRows}
              onChange={(e) => {
                setPaitingRows(Number(e.target.value))
              }}
              placeholder="Selecione"
            />
          </VStack>
          <CoastRawMaterial
            title="Pintura"
            workSchedules={workSchedules?.painting}
            rawMaterials={rawMaterialsPainting}
            handleWorkSchedule={handleWorkSchedule}
            handleRawMaterial={handleRawMaterial}
            step={Step.PINTURA}
            isDisabled={!canEdit}
          />

          <VStack spacing="8" as="form" mb="2">
            <Input
              label="Custo de EMBALAGENS"
              {...register('num_resp_packaging')}
              onBlur={(e) => {
                setValue('num_resp_packaging', e.target.value)
                handleSubmit(handleCreateOrUpdate)()
              }}
              isDisabled={!canEdit}
            />
          </VStack>

          <VStack spacing="8" as="form" mb="10">
            <Select
              label="Quantidade de linhas"
              {...register('packaging_rows')}
              options={pdfRows}
              onChange={(e) => {
                setPackgingRows(Number(e.target.value))
              }}
              placeholder="Selecione"
            />
          </VStack>
          <CoastRawMaterial
            title="Embalagem"
            workSchedules={workSchedules?.packaging}
            rawMaterials={rawMaterialsPackaging}
            handleWorkSchedule={handleWorkSchedule}
            handleRawMaterial={handleRawMaterial}
            step={Step.EMBALAGEM}
            isDisabled={!canEdit}
          />

          <Modal
            isOpen={isCreateOpen}
            onClose={onCreateClose}
            title="Novo Produto"
            buttonTitle="Adicionar"
            size="xl"
            hasFooter={false}
            buttonAction={() => {
              console.log(1)
            }}>
            <ProdcutsCreateOrUpdate selectedProduct={selectedProduct} orderId={id} onClose={onCreateClose} />
          </Modal>

          <Modal
            isOpen={isCreateScheduleOpen}
            onClose={onCreateScheduleClose}
            title="Novo Custo"
            buttonTitle="Adicionar"
            size="xl"
            hasFooter={false}
            buttonAction={() => {
              console.log(1)
            }}>
            <WorkScheduleCreateOrUpdate
              step={step}
              selectedProduct={selectedWorkSchedule}
              orderId={id}
              onClose={onCreateScheduleClose}
            />
          </Modal>

          <Modal
            isOpen={isCreateRawMaterial}
            onClose={onCreateRawMaterialClose}
            title="Novo Custo - Matéria Prima"
            buttonTitle="Adicionar"
            size="xl"
            hasFooter={false}
            buttonAction={() => {
              console.log(1)
            }}>
            <RawMaterialServiceCreateOrUpdate
              step={step}
              selectedRawMaterial={selectedRawMaterial}
              orderId={id}
              onClose={onCreateRawMaterialClose}
            />
          </Modal>

          <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Remover Produto"
            buttonTitle="Remover"
            buttonAction={handleRemoveButton}>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={RiCheckLine} color="green.500" />
                Produto: {selectedProduct?.description}
              </ListItem>
            </List>
          </Modal>

          <Modal
            isOpen={isRemoveWorkSchedule}
            onClose={onRemoveWorkScheduleClose}
            title="Remover Custo"
            buttonTitle="Remover"
            buttonAction={handleWorkScheduleremove}>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={RiCheckLine} color="green.500" />
                Hora Início: {selectedWorkSchedule?.start_work}
              </ListItem>
              <ListItem>
                <ListIcon as={RiCheckLine} color="green.500" />
                Hora Fim: {selectedWorkSchedule?.end_work}
              </ListItem>
            </List>
          </Modal>

          <Modal
            isOpen={isRemoveRawMaterial}
            onClose={onRemoveRawMaterialClose}
            title="Remover Matéria Gasta"
            buttonTitle="Remover"
            buttonAction={handleRawMaterialRemove}>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={RiCheckLine} color="green.500" />
                Quantidade: {selectedRawMaterial?.spent_amount}
              </ListItem>
            </List>
          </Modal>

          <Flex gap="4" mt="4">
            <Button bg="pink.500" onClick={handlePrintOrder}>
              Imprimir Ordem
            </Button>
            <Button bg="pink.500" onClick={onPrintEtiquetaOpen}>
              Imprimir Etiqueta
            </Button>
          </Flex>
        </Box>
      </Box>
      {/* Mostra o botão de finalizar se: tem permissão E (status não é ENTREGUE OU foi reaberto) */}
      {canViewFinancialData && serviceOrder && (serviceOrder.status !== 'ENTREGUE' || isReopened) && (
        <VStack spacing="8" mb="10">
          {/* Mostra aviso se status é CONCLUIDO mas produtos não estão todos concluídos */}
          {(serviceOrder?.status === 'CONCLUIDO' || (serviceOrder?.status === 'ENTREGUE' && isReopened)) &&
            !allProductsCompleted && (
              <Box p="4" bg="orange.100" borderRadius="md" border="1px" borderColor="orange.300" width="100%">
                <Text color="orange.700" fontWeight="bold" mb="2">
                  ⚠️ Produtos Pendentes
                </Text>
                <Text color="orange.600" fontSize="sm">
                  Todos os produtos devem estar com etapa &quot;CONCLUIDO&quot; para finalizar a ordem de serviço.
                </Text>
              </Box>
            )}
          <Button colorScheme="green" size="lg" onClick={onFinishOrderOpen} isDisabled={!canFinishOrder}>
            {serviceOrder?.status === 'ENTREGUE' && !isReopened
              ? 'Ordem Entregue'
              : canFinishOrder
              ? 'Finalizar Ordem'
              : !allProductsCompleted
              ? 'Conclua todos os produtos primeiro'
              : 'Conclua a ordem primeiro'}
          </Button>
        </VStack>
      )}

      <FinishOrderModal
        isOpen={isFinishOrderOpen}
        onClose={onFinishOrderClose}
        serviceOrderId={serviceOrder?.id}
        demandId={demands?.id}
      />

      <PrintEtiquetaModal
        isOpen={isPrintEtiquetaOpen}
        onClose={onPrintEtiquetaClose}
        products={serviceOrder?.products || []}
        onConfirm={handlePrintEtiqueta}
        isLoading={isPrintingEtiqueta}
      />
    </>
  )
}
